import { Theme } from '@mui/material';
import { TStyle } from './types.d';

export const styleSheet = (theme: Theme) => {
  const style: TStyle = {
    modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '12px',
      width: 'min(92vw, 760px)',
      minHeight: '280px',
      maxHeight: 'min(88vh, 520px)',
      height: 'auto',
      overflow: 'hidden',
      boxShadow: '0 24px 54px rgba(0, 0, 0, 0.24)',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        width: '92%',
        minHeight: 'unset',
        maxHeight: '90vh',
      },
    },
    title: {
      fontSize: '2rem',
      opacity: '0.8',
      fontWeight: 'bold',
      display: 'flex',
      width: '100%',
      flexGrow: 1,
      textAlign: 'center',
      justifyContent: 'center',
      color: theme.palette.primary.main,
      lineHeight: 1.15,
      [theme.breakpoints.down('md')]: {
        fontSize: '1.7rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.4rem',
      },
    },
    subTitle: {
      display: 'flex',
      flexGrow: 1,
      textAlign: 'center',
      justifyContent: 'center',
      color: 'black',
      lineHeight: 1.35,
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.96rem',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.05rem',
      },
    },
    subTitleLong: {
      display: 'flex',
      flexGrow: 1,
      padding: '10px 0 4px',
      textAlign: 'center',
      justifyContent: 'center',
      color: 'black',
      lineHeight: 1.45,
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.88rem',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '1rem',
      },
    },
    buttonOption: {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '8px',
      color: 'white',
      minWidth: '108px',
      minHeight: '42px',
      padding: '0 20px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.light,
        color: 'black',
        cursor: 'pointer',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.88rem',
        minWidth: '100%',
        minHeight: '40px',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '0.94rem',
      },
    },
    boxIcon: {
      backgroundColor: theme.palette.primary.main,
      width: '31%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '18px',
      borderRadius: '12px 0  0 12px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        minHeight: '118px',
        borderRadius: '12px 12px 0 0',
      },
    },
    boxInfo: {
      backgroundColor: '#ffff',
      width: '69%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '22px 24px',
      borderRadius: '0 12px 12px 0',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: '18px 16px 16px',
        borderRadius: '0 0 12px 12px',
      },
    },
  };
  return style;
};
